import React, { useState } from 'react';
import Navbar from '../assets/navbar';
import { Navigate } from "react-router-dom";
import { selectUser, requestNewPassword, requestResetPassword } from "../reducers/userSlice"
import { useAppSelector, useAppDispatch } from '../hooks'


import {
    Flex,
    Input,
    Button,
    InputGroup,
    Stack,
    Box,
    FormControl,
    Alert,
    Center,
    Image,
    Text,
  } from "@chakra-ui/react";




function AlertsEmail() {
  const user = useAppSelector(selectUser);
  if (user.error !== ''){
    return (
      <>
      <Alert status="success">
        {user.error}
      </Alert>
      <Center>
      <Text> Type your email to receive an email for resetting your password</Text>
      </Center>
      
      </>
    )
  }
  return (
  <>
  <Center>
      <Text> Type your email to receive an email for resetting your password</Text>
  </Center>

  </>
  )

}
function AlertsToken() {
  const user = useAppSelector(selectUser);
  if (user.newPasswordError !== ''){
    return (
      <>
      <Alert status="success">
        {user.newPasswordError}
      </Alert>
      <Center>
      <Text> Type the received token to reset your password</Text>
      </Center>
      
      </>
    )
  }
  return (
  <>
  <Center>
      <Text> Type the received token to reset your password</Text>
  </Center>

  </>
  )

}

export default function ForgottenPassword(){
    const user = useAppSelector(selectUser);
    const dispatch = useAppDispatch();
    
    const [reqDataState, setData] = useState({
        email: "",
      });
    
      const [reqTokenState, setToken] = useState({
        token: "",
      });

    const handleSubmit = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setData({ ...reqDataState});
        
        let reqData = {
          email: reqDataState.email,
        }
        let jsonReq = JSON.stringify(reqData)
        dispatch(requestNewPassword(jsonReq));
      };  

    const changeHandler = (e: { target: { name: string; value: string; }; }) => {
        if (e.target.name === "email") {
          setData({ ...reqDataState, [e.target.name]: e.target.value.trim() });
        } else {
          setData({ ...reqDataState, [e.target.name]: e.target.value });
        }
      };

      const handleSubmitToken = (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        setData({ ...reqDataState});
        
        let reqToken = {
          token: reqTokenState.token,
        }
        dispatch(requestResetPassword(reqToken.token));
      };
      const changeHandlerToken = (e: { target: { name: string; value: string; }; }) => {
        if (e.target.name === "token") {
          setToken({ ...reqTokenState, [e.target.name]: e.target.value.trim() });
        } else {
          setToken({ ...reqTokenState, [e.target.name]: e.target.value });
        }
      };
      
      if (user.loggedIn) {
        return <Navigate to="/SettingsPage" />;
      }
      
    return (
        <>
        <Navbar/>
        <Flex 
        flexDirection="column"
        width="100%"
        height="85vh"
        justifyContent="center"
        alignItems="center"
        marginBottom="100px"  
        >
            <Stack
            flexDir="column"
            mb="2"
            justifyContent="center"
            alignItems="center"
            >
            <Box minW={{ base: "90%", md: "200px" }}>
                <Image src="logo_nav.svg" />
            </Box>

        <Text
          marginBottom="10px"
          fontSize="30px"
          fontWeight="bold"
          color="#211a52"
        >
          Reset password
        </Text>
        <Box minW={{ base: "90%", md: "468px" }}>
            <form onSubmit={handleSubmit}>
                <Stack
                spacing={4}
                p="1rem"
                backgroundColor="whiteAlpha.900"
                boxShadow="md"
                >
                <FormControl>
                    <InputGroup>
                    <Input mb={2}
                    type="text"
                    name="email"
                    placeholder="Email"
                    onChange={changeHandler}
                    id='email'
                  />
                    </InputGroup>
            
                </FormControl>
                <Button
                
                type="submit"
                variant="solid"
                backgroundColor="#211a52"
                color="white"
                width="full"
              >
                Reset password
              </Button>
                </Stack>
            </form>
            <AlertsEmail/>
        </Box>
            </Stack>

        <Stack
            flexDir="column"
            mt="14"
            justifyContent="center"
            alignItems="center"
            >
        <Text
          marginBottom="10px"
          fontSize="30px"
          fontWeight="bold"
          color="#211a52"
        >
          Get New Password
        </Text>
        <Box minW={{ base: "90%", md: "468px" } }>
            <form onSubmit={handleSubmitToken}>
                <Stack
                spacing={4}
                p="1rem"
                backgroundColor="whiteAlpha.900"
                boxShadow="md"
                >
                <FormControl>
                    <InputGroup>
                    <Input mb={2}
                    type="text"
                    name="token"
                    placeholder="token"
                    onChange={changeHandlerToken}
                    id='token'
                  />
                    </InputGroup>
            
                </FormControl>
                <Button
                
                type="submit"
                variant="solid"
                backgroundColor="#211a52"
                color="white"
                width="full"
              >
                Submit reset token
              </Button>
                </Stack>
            </form>
            <AlertsToken/>
        </Box>
            </Stack>
        </Flex>
        </>
    );
}